export default __webpack_public_path__ + "images/9ee94f13b5c39e56e1b556843b672a69.png";